export default defineNuxtRouteMiddleware(async (to, from) => {
    const user = useState('profile')
    const token = useCookie('auth_token')
    const config = useRuntimeConfig()

    if (!token.value && !to.meta.public) {
        return navigateTo('/login')
    }

    if (token.value && !user.value) {
        try {
            user.value = (await $fetch(`https://www.${config.public.domain}/api/user/me`, {
                headers: {
                    Authorization: `Bearer ${token.value}`
                },
            })).user
        } catch (error) {
            token.value = null

            if (!to.meta.public) {
                return navigateTo('/login')
            }
        }
    }
})